import { http } from "~/utils/axios.util"


export type IPostDonationRequest = {
  amount: number;
  projectDescription: string;
  returnUrl?: string;
}

export const DonationRepository = {
  Post: (request: IPostDonationRequest) =>
    http.post<string>('donation', request),
}